module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Student-01-f04b2bcf000c4153ed059b233dd2c824.png";